import { saleItemIsProductColor } from '../../../../../modules/catalogs/utils/saleItemType.utils';
import ProductCodesTooltip from '../../../../../modules/products/components/ProductCodesTooltip';
import { formatProductCodes } from '../../../../../modules/products/utils/productCodes.utils';
import Typography from '../../../../v2/ui/Typography/Typography';
import { CatalogItemRelations } from '../../ProductCard/types/productCard.types';
import { PRODUCT_NAME_CLASSNAME, useProductCardV2Styles } from '../productCardV2.styles';

interface ProductCardV2HeadingProps {
  name: string;
  code: string;
  entityRelations: CatalogItemRelations;
  referenceCode?: string;
  nameTestId?: string;
  codesTestId?: string;
  codesTabIndex?: number;
  showTooltipContent?: boolean;
}

const ProductCardV2Heading = ({
  name,
  code,
  entityRelations,
  referenceCode,
  nameTestId,
  codesTestId,
  codesTabIndex,
  showTooltipContent,
}: ProductCardV2HeadingProps) => {
  const { classes, cx } = useProductCardV2Styles({});

  const codes = formatProductCodes({
    code,
    referenceCode: saleItemIsProductColor(entityRelations) ? referenceCode : undefined,
  });

  const codesTitle = showTooltipContent ? undefined : codes;

  return (
    <div>
      <Typography
        variant="subtitle2"
        className={cx(classes.productName, PRODUCT_NAME_CLASSNAME)}
        title={name}
        testId={nameTestId}
      >
        {name}
      </Typography>

      <ProductCodesTooltip
        productCode={code}
        productReferenceCode={referenceCode}
        tabIndex={codesTabIndex}
        showTooltipContent={showTooltipContent}
      >
        <Typography
          variant="body2"
          color="textSecondary"
          noWrap
          testId={codesTestId}
          title={codesTitle}
          className={classes.productCode}
        >
          {codes}
        </Typography>
      </ProductCodesTooltip>
    </div>
  );
};

export default ProductCardV2Heading;
